import { FC } from 'react';
// components
import ExcipientTypeComponent from 'components/main/ExcipientType/Add';

const Add: FC = () => <ExcipientTypeComponent />;

export default Add;
